import Vue from 'vue';
import { Tabbar, TabbarItem } from 'vant';
import 'vant/lib/index.css';
import '@assets/scss/officialTopup/font/icon.js';

if (window.hwerrVue) {
  Vue.config.errorHandler = window.hwerrVue;
}



import AnalyzePoint, {
  routerEnter
} from '../../resource/plugins/AnalyzePoint/index';

import App from '../../officialTopupApp.vue';
import router from '../rooters/officialTopup';
import store from '../stores/officialTopup';
import commonComponents from '@components/officialTopup/common/commonComponents';
import clickThrottling from '../../resource/plugins/clickThrottling';
import 'swiper/css/swiper.css';
import { handleStoreDefaultCid } from '@utiles/storeHandleCid';
import '@plugins/replaceAllPolyfills';
import globalConfig from '@utiles/officialStore/globalConfig';
import bridge from '@utiles/bridge';
import { ensureV3PointFallback } from '@plugins/biPoint/ensureBiPoint';

// ！！！注意：重定向逻辑要在initBiPoint之前，否则会导致【会话开始】打点打在旧页面.
// 重定向逻辑 start
const gameId =
  globalConfig.getHrefParam('gameId') ||
  globalConfig.getHrefParam('gameID') ||
  globalConfig.getHrefParam('game_id') ||
  '';

if ([175, 405, 426, 371].includes(+gameId)) {
  const currentUrl = new URL(window.location);
  currentUrl.pathname = currentUrl.pathname.replace(
    'officialTopup.html',
    'officialTopupNew.html'
  );

  // 2025.7.8 ROV跳转ROG V3第三方支付页
  if (gameId == 371) {
    currentUrl.searchParams.set('gameId', 426);
  }

  if (bridge.runInsdk()) {
    bridge.callSdkMethod('openWebView', {
      url: currentUrl.href,
      loginDir: 0,
      appendParams: 1,
      pageOrientation: 1
    });
  } else {
    window.location.href = currentUrl.href;
  }
}

// 重定向逻辑 end
handleStoreDefaultCid();
ensureV3PointFallback();

Vue.use(Tabbar);
Vue.use(TabbarItem);

Vue.use(AnalyzePoint('global-pay', 'officialTopup', true));
// 设置点击节流.
Vue.use(clickThrottling);
clickThrottling.setThrottlingTime(800);

Vue.config.productionTip = true;
Vue.use(commonComponents);

router.beforeEach((to, _from, next) => {
  routerEnter(to.name);
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#officialTopup');
